import ClickAwayListener from '../../../../components/ClickAwayListener';
import Fade from '@material-ui/core/Fade';
import Popper, { PopperProps } from '@material-ui/core/Popper';
import clsx from 'clsx';
import React, { SyntheticEvent, useRef, useState } from 'react';
import { Icon } from '../../../../components/Icon';

type Align = 'left' | 'right';

export interface TopLevelNavigationDropdownItemProps {
    additionalClasses?: string[];
    label: React.ReactNode;
    url: string;
    children: React.ReactNode;
    align?: Align;
    showArrow?: boolean;
    popperModifiers?: PopperProps['modifiers'];
}

export function TopLevelNavigationDropdownItem({
    additionalClasses = [],
    url,
    label,
    showArrow = true,
    popperModifiers = {},
    align = 'left',
    children,
}: TopLevelNavigationDropdownItemProps) {
    const [isOpen, setIsOpen] = useState(false);
    const classes = clsx('top-level-nav__item', ...additionalClasses);
    const [triangle, setTriangle] = useState<HTMLSpanElement | null>(null);
    const placement = align === 'left' ? 'bottom-start' : 'bottom-end';
    const triggerEl = useRef<HTMLAnchorElement | null>(null);

    const handleClick = (event: SyntheticEvent<any>): void => {
        event.preventDefault();
        setIsOpen(prevIsOpen => !isOpen);
    };

    const setTriangleEl = (node: HTMLSpanElement) => {
        setTriangle(node);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const elementId = `top-level-dropdown-${url}`;

    return (
        <div className={classes}>
            <a
                className="top-level-nav__item__link"
                href={url}
                onClick={handleClick}
                aria-haspopup="true"
                aria-owns={isOpen ? elementId : undefined}
                ref={triggerEl}
            >
                {label}
                {showArrow && <Icon type="down-2" variations={['offset-left', 'inline']} />}
            </a>
            <Popper
                id={elementId}
                transition
                placement={placement}
                modifiers={{
                    flip: { enabled: false },
                    offset: { enabled: true, offset: '0, 10px' },
                    arrow: { enabled: true, element: triangle },
                    ...popperModifiers,
                }}
                anchorEl={triggerEl.current}
                open={isOpen}
                style={{ zIndex: 99 }}
            >
                {({ TransitionProps }) => {
                    return (
                        <ClickAwayListener onClickAway={handleClose}>
                            <Fade {...TransitionProps}>
                                <div className="popper-card">
                                    <span className="popper-card__arrow" ref={setTriangleEl} />
                                    <div className="popper-card__content">{children}</div>
                                </div>
                            </Fade>
                        </ClickAwayListener>
                    );
                }}
            </Popper>
        </div>
    );
}

export default TopLevelNavigationDropdownItem;
